module.exports = __webpack_public_path__ + "static/img/major_pictgrid37_1080x843.4bcd736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid37_1080x843.jpg
// module id = Rc32
// module chunks = 0